import { get } from 'lodash';

import { ConfigurationInterface } from './_configurationTypes';
import { CONFIGURATION_TYPE } from './_configurationConstants';

export const getConfig = ({ addError }) => async (): Promise<ConfigurationInterface | null> => {
  try {
    const response = await fetch('/metropolis/api/common/app/properties', {
      method: 'GET'
    });
    if (response.ok) {
      const config: ConfigurationInterface = await response.json();

      const unparsedModules = get(config, 'modules', {});
      const modules: Array<string> = Object.keys(unparsedModules).filter(m => !!unparsedModules[m]);

      return { ...config, modules };
    } else {
      throw new Error();
    }
  } catch {
    addError('Nelze načíst konfiguraci metropolisu. Kontaktujte administrátora.');
    return null;
  }
};

export const setConfig = ({ dispatchConfiguration }) => payload => {
  dispatchConfiguration({ type: CONFIGURATION_TYPE.CONFIG, payload });
};

export const setSettings = ({ dispatchConfiguration }) => payload => {
  dispatchConfiguration({ type: CONFIGURATION_TYPE.SETTINGS, payload });
};



// WEBPACK FOOTER //
// ./src/components/provider/configuration/_configurationActions.ts